import css from './Member.module.css'
import { useWorkspace } from '../../../contexts/WorkspaceContext'
import { TextNorm, TextH2 } from '../../ui/Text'
import Avatar from '../../ui/Avatar/Avatar'
import { getMemberDisplayName } from '@/utils/memberDisplayName'

interface MemberProps {
    userId: string
    size?: 'default' | 'medium'
    onClick?: () => void
}

const Member = ({ userId, size = 'default', onClick }: MemberProps) => {
    const { getMember } = useWorkspace()
    const member = getMember(userId)

    if (!member) {
        return null
    }

    const Text = size === 'medium' ? TextH2 : TextNorm
    const avatarSize = size === 'medium' ? 'medium' : 'small'
    const containerClassName = size === 'medium' ? `${css.container} ${css.container_medium}` : css.container
    const displayName = getMemberDisplayName(member)

    return (
        <div className={containerClassName} onClick={onClick} style={onClick ? { cursor: 'pointer' } : undefined}>
            <Avatar
                title={displayName}
                color={member.color}
                avatar={member.avatarImage}
                size={avatarSize}
            />
            <div>
                <Text>{displayName}</Text>
            </div>
        </div>
    )
}

export default Member
